const initialState = {
  isLightMode: false,
};

/**
 * @function lightModeReducers
 * @summary lightModeReducers reducers that change light mode global state.
 * @param {object} state - Initial global state.
 * @param {func} action - Action object.
 * @return {object} Updated global state.
 */
const lightModeReducers = (state = initialState, action) => {
  switch (action.type) {
    case 'SWITCH_LIGHT':
      return {
        ...state,
        isLightMode: !state.isLightMode,
      };
    default:
      return state;
  }
};

export default lightModeReducers;
